<template>
  <div>
  <div v-if="config" style="padding: 10px">
    <div style="">
      <div style="border: 1px solid gray; padding: 10px">
        <h1>Logged in as {{config.agent}}</h1>
        <div style="margin-top: 20px">Make call from
          <select v-model="fromNumber">
            <option v-for="number in Object.keys(config.agents[config.agent].phoneNumbers)" :key="number" :value="number">
              {{number}}
            </option>
          </select><br/><br/>
          <span class="">to <input type="tel" @input="updateConfig"  v-model="destinationNumber" style="border: 1px solid gray;padding: 5px;" /></span><br/><br />
          via
          <select v-model="proxyNumber">
            <option v-for="number in Object.keys(config.phoneNumbers)" :key="number" :value="number">
              {{number}} {{ config.phoneNumbers[number].label }}
            </option>
          </select>
        </div>
        <button v-if="proxyNumber && getCallee() && !updatingConfig" @click="callDestination" style="display: inline-block;margin-top:20px;padding: 10px;background-color: orange;color: white;cursor: pointer">
          CALL {{getCallee().name}}
        </button>
        <button v-else-if="proxyNumber" disabled style="display: inline-block;margin-top:20px;padding: 10px;background-color: gray;color: white;cursor: pointer">
          CALL {{getCallee().name}}
        </button>
      </div>
      <div style="border: 1px solid gray; padding: 10px; margin-top: 10px;">
        <div style="margin-top: 20px">Send SMS
          to <input type="tel" v-model="destinationNumber" style="border: 1px solid gray;padding: 5px;" /><br/><br />
          Text <textarea v-model="smsText" style="width: 300px; height: 50px"></textarea>
        </div>
        <button @click="sendSms" style="display: inline-block;margin-top:20px;padding: 10px;background-color: orange;color: white;cursor: pointer">SEND</button>
      </div>
      <div style="border: 1px solid gray; padding: 10px; margin-top: 10px;">
        <h1 style="margin-bottom: 20px">Routing configuration</h1>
        <div><input id="pin" name="pin" type="checkbox" v-model="config.stickyMode" /> Persistent Mode (12 hour window for sticky calls)</div>
        <div v-for="number in Object.keys(config.phoneNumbers)" style="margin-top: 10px" >
          {{number}} <b>{{ config.phoneNumbers[number].label }}</b>
          <select v-model="config.phoneNumbers[number].forwardTo">
            <option v-for="agent in Object.keys(config.agents)" :key="agent" :value="Object.keys(config.agents[agent].phoneNumbers)[0]">
              {{agent}}
            </option>
          </select>
        </div>
        <button @click="updateRouting" style="display: inline-block;margin-top:20px;padding: 10px;background-color: orange;color: white;cursor: pointer">SAVE</button>
      </div>
    </div>
  </div>
  <div style="margin-top: 10px;">
      <div class="data-table" id="calls-table">
      <div class="header">
        <div>At</div>
        <div>From</div>
        <div>FromUser</div>
        <div>Via</div>
        <div>ToUser</div>
        <div>To</div>
        <div>Status</div>
        <div>Rec</div>
        <div>Len</div>
      </div>
        <div v-for="log in logs" :key="log.receivedAt" class="row">
          <div class="cell">{{new Date(log.receivedAt).toLocaleDateString() + ' ' + new Date(log.receivedAt).toLocaleTimeString()}}</div>
          <div class="cell"><a style="text-decoration:underline;cursor:pointer" @click="navigatePhone(log.from)">{{log.from}}</a></div>
          <div class="cell"><a style="text-decoration:underline;cursor:pointer" :href="navigateUser(log.fromUser)">{{ getUserName(log.fromUser, log.from) }}</a></div>
          <div class="cell">{{log.via}}</div>
          <div class="cell"><a style="text-decoration:underline;cursor:pointer" :href="navigateUser(log.toUser)">{{ getUserName(log.toUser, log.to) }}</a></div>
          <div class="cell"><a style="text-decoration:underline;cursor:pointer" @click="navigatePhone(log.to)">{{log.to}}</a></div>
          <div class="cell">{{log.status}}</div>
          <div class="cell">
            <router-link v-if="log.text" :to="{ name: 'smsPage', query: { text: log.text } }">Text</router-link>
            <a v-else :href="log.recordingUrl" target="_blank">Rec</a>
          </div>
          <div class="cell">{{log.duration || (log.text && log.text.length) }}</div>
        <!-- <td>{{log.agent}}</td> -->
      </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  td, th {
    border: 1px solid gray;
    padding: 8px;
  }
  #calls-table {
    grid-template-columns: auto auto auto auto auto auto auto auto auto;
  }
</style>

<script>
import api from '../services/api';

export default {
  data() {
    return {
      config: false,
      proxyNumber: '+37064721799',
      fromNumber: '',
      smsText: this.$route.query.text || '',
      destinationNumber: this.$route.query.phoneNumber || '',
      logs: [],
      updatingConfig: false
    }
  },
  async created() {
    document.title = 'Callcentre';
    const config = await api.getCallcentreConfig();
    this.config = config;
    // this.proxyNumber = '';
    if (this.destinationNumber) {
      Object.keys(config.phoneNumbers).forEach(num => {
        if (num.substring(0,3) === this.destinationNumber.substring(0, 3)) {
          this.proxyNumber = num;
        }
      });
    }
    this.fromNumber = Object.keys(config.agents[config.agent].phoneNumbers)[0];
    this.logs = (await api.getCallcentreLogs({phoneNumber: this.$route.query.phoneNumber})).logs;
    if (this.$route.query.phoneNumber) {
      this.updateConfig()
    }
  },
  methods: {
    getCallee() {
      return (this.config.agents[this.config.agent].phoneNumbers[this.fromNumber] || {}).callee;
    },
    async sendSms() {
      if (!this.destinationNumber.startsWith('+')) {
        return;
      }
      if (confirm(`Send SMS to ${this.destinationNumber} '${this.smsText}'?`)) {
        await api.sendSms(this.destinationNumber, this.smsText);
        window.location.reload();
      }
    },
    getUserName(data, phone) {
      if (!data) {
        return '';
      }
      const agents = Object.keys(this.config.agents);
      for (let i = 0; i < agents.length; i++) {
        const agent = this.config.agents[agents[i]];
        if (Object.keys(agent.phoneNumbers).includes(phone)) {
          return '[AGENT] ' + agents[i].split('@')[0];
        }
      }
      let name = '';
      if (data.verified) {
        name += '[PRO] ';
      } else if (data.type === 'contact') {
        name += '[B2B] ';
      } else {
        name += '[B2C] '
      }
      name += data.name;
      return name;
    },
    async updateConfig() {
      console.log('updateConfig', this.proxyNumber);
      this.updatingConfig = true;
      const data = await api.updateCallcentreConfig(this.config.agent, this.fromNumber, this.destinationNumber);
      this.config = data;
      this.updatingConfig = false;
      // window.open('tel:' + this.proxyNumber, '_parent'); 
    },
    async callDestination() {
      window.open('tel:' + this.proxyNumber, '_parent'); 
    },
    async updateRouting() {
      // console.log('updateConfig', this.proxyNumber);
      await api.updateCallcentreRouting(this.config.phoneNumbers, this.config.stickyMode);
      window.location.reload(); 
    },
    navigateUser(data) {
      let link = '';
      if (!data) {
        return link;
      }
      if (data.type === 'user' && data.verified) {
        link = this.$router.resolve({name: "orders", query: {filter: 'search', workerId: data.id}}).href;
      } else if (data.type === 'user') {
        link = this.$router.resolve({name: "orders", query: {filter: 'search', clientId: data.id}}).href;
      } else if (data.type === 'contact') {
        link =this.$router.resolve({name: "orders", query: {filter: 'search', contactId: data.id}}).href;
      }
      return link;
    },
    async navigatePhone(number) {
      this.$router
        .push({ name: "call", query: { phoneNumber: number } })
        .catch(() => {});
      this.destinationNumber = number;
      await this.updateConfig()
    }
  }
}
</script>
